export const formatBytes = (bytes: number | null | undefined): string => {
    if (!bytes) return '0 B'

    const units = ['B', 'KB', 'MB', 'GB', 'TB']
    const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
    const value = bytes / Math.pow(1024, index)

    return `${value % 1 === 0 ? value : value.toFixed(1)} ${units[index]}`
}

export const parseEmptyValue = <T>(value: T | null | undefined, placeholder = '-'): T | string => {
    if (value == null) return placeholder

    const stringified = value.toString().trim()
    if (!stringified) return placeholder

    if (typeof value === 'string') return stringified

    return value
}

export const formatPrice = (value: number | string | null | undefined): string => {
    const num = Number(String(value ?? 0).replace(',', '.'))
    const safe = Number.isNaN(num) ? 0 : num

    return safe.toFixed(2).replace('.', ',')
}

export const unformatPrice = (value: number | string | null | undefined): string | undefined => {
    if (value == null || value === '') return undefined
    const cleaned = String(value)
        .replace(/,/g, '.')
        .replace(/[^0-9.-]+/g, '')
    const num = Number(cleaned)

    return Number.isNaN(num) ? undefined : num.toFixed(2)
}

export const isValidPriceInput = (value: number | string | null | undefined): boolean => {
    if (value === null || value === undefined) {
        return false
    }

    return /^\d+([.,]\d{1,2})?$/.test(String(value).trim())
}

export const formatWeight = (weight: number | string | null | undefined): string => {
    if (weight == null || Number.isNaN(Number(weight))) {
        return '-'
    }

    const formatted = String(weight).replace('.', ',')
    return formatted ? `${formatted} kg` : '-'
}

export const roundWeight = (weight: number | string | null | undefined, precision = 1000): number | '-' => {
    const value = Number(weight)
    if (!Number.isNaN(value) && weight !== null) {
        return Math.round(value * precision) / precision
    }

    return '-'
}

export const capitalize = (value = ''): string => value.charAt(0).toUpperCase() + value.slice(1)

export const parseUserInitials = (value: string): string => {
    const text = value.trim()
    if (!text) return ''

    const parts = text
        .split(' ')
        .map((part) => part.trim())
        .filter(Boolean)

    if (parts.length >= 2) {
        return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase()
    }

    return text.substring(0, 2).toUpperCase()
}
